import { Map } from 'immutable';

import { shapeKeywordsForAPI } from '../product/shapeAttributes';

import { OPERATIONS } from '@/constants/product';
import { ATTRIBUTE } from '@/constants/attributes';

export function editKeywords({ product, value }) {
  const channel = product.get('channel');

  return {
    product: product.set(ATTRIBUTE.KEYWORDS, value),
    operations: [
      Map({ type: OPERATIONS[channel].KEYWORDS, value: shapeKeywordsForAPI({ channel, value }) }),
    ],
  };
}
